<template>
  <div class="page-wrapper">
    <ChannelPricing @tab="switchTab" v-if="tab_switch == 'channel' && $checkPermission('video_storage')">
    </ChannelPricing>
    <StreamingPricing @tab="switchTab" v-if="tab_switch == 'streaming' && $checkPermission('event_streaming')">
    </StreamingPricing>
    <VotingPricing @tab="switchTab" v-if="tab_switch == 'voting' && $checkPermission('voting')"></VotingPricing>
    <EventPricing @tab="switchTab" v-if="tab_switch == 'events' && $checkPermission('events')"></EventPricing>
    <DonationPricing @tab="switchTab" v-if="tab_switch == 'donation' && $checkPermission('donation')"></DonationPricing>
  </div>
</template>
<script>
import ChannelPricing from "./ChannelPricing.vue";
import StreamingPricing from "./StreamingPricing.vue";
import VotingPricing from "./VotingPricing.vue";
import EventPricing from "./EventPricing.vue";
import DonationPricing from "./DonationPricing.vue"
export default {
  components: {
    ChannelPricing,
    StreamingPricing,
    VotingPricing,
    EventPricing,
    DonationPricing
  },
  data: () => ({
    tab_switch: "channel",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "channel";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    } else {
      if (vm.$checkPermission('video_storage')) {
        vm.tab_switch = 'channel';
      } else if (vm.$checkPermission('event_streaming')) {
        vm.tab_switch = 'streaming';
      } else if (vm.$checkPermission('voting')) {
        vm.tab_switch = 'voting';
      } else if (vm.$checkPermission('events')) {
        vm.tab_switch = 'events';
      } else if (vm.$checkPermission('donation')) {
        vm.tab_switch = 'donation';
      }
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "s_pricing", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>
